import { createContext, useContext, useState, useEffect } from 'react';
import { getSiteSettings } from '@/lib/api';

const AdContext = createContext(null);

export const useAds = () => {
  const context = useContext(AdContext);
  if (!context) {
    throw new Error('useAds must be used within an AdProvider');
  }
  return context;
};

export const AdProvider = ({ children }) => {
  const [adSettings, setAdSettings] = useState({
    header_ad_code: null,
    sidebar_ad_code: null,
    footer_ad_code: null,
    popup_ad_code: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await getSiteSettings();
        setAdSettings(response.data);
      } catch (error) {
        console.error('Failed to load ad settings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return (
    <AdContext.Provider value={{ adSettings, loading, setAdSettings }}>
      {children}
    </AdContext.Provider>
  );
};
